module.exports = __webpack_public_path__ + "img/life-cycle.5b47a867.png";